/* RESPONSIBLE TEAM: team-proactive-support */
import PanelConfiguration from 'embercom/objects/content-editor/panel-configuration';
import SeriesScheduleHeaderConfiguration from 'embercom/objects/content-editor/panels/schedule/series-schedule-header-configuration';
import ComponentConfiguration from 'embercom/objects/content-editor/component-configuration';
import { assert } from '@ember/debug';
import { timezoneTypes } from 'embercom/models/data/matching-system/matching-constants';
import { contentEditors } from 'embercom/models/data/matching-system/matching-constants';

export default class SeriesSchedulePanelConfiguration extends PanelConfiguration {
  init(inputs) {
    // The container gives us access to Services in these objects. Pass `container: getOwner(this)` as an
    // input when generating these configuration objects.
    assert('You must provide the application container in your panel inputs', inputs.container);

    let header = SeriesScheduleHeaderConfiguration.create(
      {
        title: inputs.title,
      },
      { container: inputs.container },
    );
    let body = ComponentConfiguration.create({
      component: 'content-editor/panels/schedule/series-body',
      timezoneType: inputs.timezoneType || timezoneTypes.basedOnAppTimezone,
    });
    super.init({
      name: 'schedule',
      header,
      body,
      supportedEditors: [contentEditors.series],
    });
  }
}
